import { useState } from 'react';
import { randomIntFromInterval } from 'shared/utils';

export const useRandomNumber = (minValue, maxvalue) => {
  const [randomNumber] = useState(randomIntFromInterval(minValue, maxvalue));
  return randomNumber;
};
